import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { useSPIntl } from 'hooks/useIntl';
import { QuoteKeys, QuoteKeysPrefix } from 'locales/quoteKeys';
import { FormRecord, TranslatedValidationError } from 'models/formError';
import { selectEssentialValidationFormErrors } from 'state/essential/infos/selectors';
import { translateValidationError } from 'utils/errors/form-validation-errors';

export const useFormErrors = () => {
  const SPIntl = useSPIntl();

  const tabId = useAssertedActiveTabId();
  const formErrors = useAppSelector(state => selectEssentialValidationFormErrors(state, tabId));

  const getFieldError = (fieldId: string): TranslatedValidationError | undefined => {
    const error = formErrors.find(error => error.fields?.[0] === fieldId);

    if (!error) {
      return undefined;
    }

    return translateValidationError<FormRecord, QuoteKeys, QuoteKeysPrefix>(error, SPIntl, 'quote.errorMessages.');
  };

  return { formErrors, getFieldError };
};
